/**
 * Scroll to given element with animation.
 * Optional: Prevent sticky header from appearing.
 */
export function scrollToElement(
	$elm: any,
	preventFixedHeader: boolean,
	additionalOffsetTop: number = 0,
	triggerScrollReached: boolean = false,
	topOnly: boolean = false
) {
	const offset = $elm.offset();
	const element = $elm[0];  
	if (preventFixedHeader) {
        $(window).trigger('enablePreventStickyHeaderAppearing');
    }
    const scrollOptions: ScrollIntoViewOptions = {
        behavior: 'smooth',
        block: 'start',
		inline: topOnly ? 'nearest' : 'start',
    };

    if (element) {
        element.scrollIntoView(scrollOptions);
	}
    setTimeout(() => {
        $(window).trigger('disablePreventStickyHeaderAppearing');
		if (triggerScrollReached) {
            $elm.trigger('scrollReached');
        }
    }, 100);
}

export default { scrollToElement };
